import { Box, Button, makeStyles } from "@material-ui/core";
import { useIsInternalAdmin } from "Components/Members/hooks/useIsInternalAdmin";
import { useScheduleResourceModal } from "Components/ScheduleResource/hooks/useScheduleResourceModal";
import { useScheduleResources } from "Components/ScheduleResource/hooks/useScheduleResources";
import { useTeamsModal } from "Components/Team/hooks/useTeamsModal";
import { px } from "Configs/theme";
import {
	IsCalendarSubHeadOpen,
	SetIsCalendarSubHeadOpen,
} from "Helpers/LocalStorageHelper";
import { useIsBrowserOrIpadOs } from "Helpers/PlatformHelper";
import { useTranslation } from "Providers/TranslationProvider";
import ErrorView from "Views/ErrorView";
import LoadingIndicator from "Views/LoadingIndicator";
import { ScheduleResource } from "domain-entities";
import React, { FC, Fragment } from "react";
import { v4 } from "uuid";
import CalendarSubHeadRow from "./CalendarSubHeadRow";

interface Props {
	scheduleGroupResourceIds: string[];
	isCalendarSubHeadOpen: IsCalendarSubHeadOpen;
	setIsCalendarSubHeadOpen: SetIsCalendarSubHeadOpen;
	renderResourceRow: (scheduleResource: ScheduleResource) => JSX.Element;
}

const CalendarResourceRows: FC<Props> = (props) => {
	const { t } = useTranslation();
	const isInternalAdmin = useIsInternalAdmin();
	const isBrowserOrIpadOs = useIsBrowserOrIpadOs();
	const classes = useStyles();

	const isInitializingScheduleResources = useScheduleResources(
		(state) => state.isInitializing
	);
	const scheduleResourcesError = useScheduleResources((state) => state.error);
	const scheduleResources = useScheduleResources((state) => state.items);

	function renderRows() {
		if (isInitializingScheduleResources) {
			return <LoadingIndicator />;
		} else if (scheduleResourcesError) {
			return <ErrorView error={scheduleResourcesError} />;
		} else if (scheduleResources.length === 0) {
			return <Box p={px.xl}>{t("CalendarView_EmptyRow_Resources")}</Box>;
		} else {
			return scheduleResources
				.filter(
					(scheduleResource) =>
						!props.scheduleGroupResourceIds.includes(scheduleResource.id)
				)
				.map(props.renderResourceRow);
		}
	}

	function handleModalsOpen() {
		useTeamsModal.getState().open();
		useScheduleResourceModal.getState().openWithItem(
			{
				id: v4(),
				name: "",
			},
			true
		);
	}

	return (
		<Fragment>
			<CalendarSubHeadRow
				title={t("CalendarResourceRows_Title")}
				isOpen={props.isCalendarSubHeadOpen.resources}
				setIsOpen={(isOpen) =>
					props.setIsCalendarSubHeadOpen("resources", isOpen)
				}
			>
				{" "}
				{isInternalAdmin && isBrowserOrIpadOs && (
					<Button
						className={classes.button}
						color="primary"
						size="small"
						onClick={handleModalsOpen}
					>
						+ {t("CalendarResourceRows_Button_AddResource")}
					</Button>
				)}
			</CalendarSubHeadRow>
			{props.isCalendarSubHeadOpen.resources && renderRows()}
		</Fragment>
	);
};

export default CalendarResourceRows;

const useStyles = makeStyles({
	button: {
		marginRight: px.l,
	},
});
